import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import VerticalLayout from "components/VerticalLayout";
import HorizontalLayout from "components/HorizontalLayout";
import { layoutTypes } from "../../constants/layout";

const Authmiddleware = (props) => {
  const location = useLocation();

  const { layoutType } = useSelector(state => ({
    layoutType: state.Layout.layoutType,
  }));

  const getLayout = (layoutType) => {
    let Layout = VerticalLayout;
    switch (layoutType) {
      case layoutTypes.VERTICAL:
        Layout = VerticalLayout;
        break;
      case layoutTypes.HORIZONTAL:
        Layout = HorizontalLayout;
        break;
      default:
        break;
    }
    return Layout;
  };

  const Layout = getLayout(layoutType);
  const authUser = localStorage.getItem("authUser");

  if (!authUser) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: location } }} replace />
    );
  }

  if (localStorage.getItem("isProfileLocked") === "true") {
    return (
      <Navigate to={{ pathname: "/auth-lock-screen", state: { from: location } }} replace />
    );
  }

  return (
    <React.Fragment>
      <Layout>{props.children}</Layout>
    </React.Fragment>
  );
};

export default Authmiddleware;